module.exports = __webpack_public_path__ + "static/media/Leftarrow.921df9fc.svg";